// LoaderWithTimer.js
import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({ timeout = 60000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  return visible ? (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </div>
  ) : null;
};

export default Loader;
